import { render, staticRenderFns } from "./ShiftsSettings.vue?vue&type=template&id=0374ced6"
import script from "./ShiftsSettings.vue?vue&type=script&lang=js"
export * from "./ShiftsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports